// Emberdose Christmas Couples Jar — shared utilities.
// This file is loaded by every "christmas-*" section on the page. Because several
// sections each include a <script> tag pointing at this file, the code below guards
// itself so the setup logic only ever runs once, no matter how many sections load it.
(function () {
  if (window.__emberXmasV2Booted) { return; }
  window.__emberXmasV2Booted = true;

  function boot() {
    // ---- smooth scroll for in-page anchor links ----
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
      });
    });

    // ---- scroll reveal ----
    var els = document.querySelectorAll('.reveal,.reveal-left,.reveal-right,.reveal-scale');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: .15, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
